<template>
  <div :style="style" class="preview-container">
    <template v-if="isImage && file.signedUrl">
      <img :src="file.signedUrl" :alt="file.title" class="image-preview" />
    </template>
    <template v-else>
      <i v-if="isFontAwesome" :class="[icon, large ? 'large' : 'normal']" />
      <component
        v-else
        :is="svgComponent"
        :class="['svg-icon', large ? 'large' : 'normal']"
      />
    </template>
  </div>
</template>


<script>
export default {
  props: {
    file: {
      type: Object,
      required: true,
    },
    large: {
      type: Boolean,
      default: false,
    },
    svgComponent: {
      type: [Object, String],
      default: false,
    },
  },

    created() {
    console.log(this.svgComponent);
  },

  computed: {
    isImage() {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
      return imageExtensions.includes(this.file.extension);
    },
    isFontAwesome() {
      return this.file.icon && typeof this.file.icon === 'string';
    },

    icon() {
      return this.isFontAwesome ? ['fa', this.file.icon] : null;
    },
    style() {
      return this.file.signedUrl && this.isImage
        ? {}
        : { backgroundColor: '#fff' };
    },
  },
};
</script>

<style lang="scss" scoped>
  .preview-container {
    display: flex;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #fff;
  }

  .image-preview {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
    display: block;
  }

  i, .large, .normal, .svg-icon {
    color: #555;
    margin: auto auto;
    font-size: 36px;
    height: 42px;
  }

  .normal, .svg-icon.normal {
    width: 36px;
    height: 42px;
  }

  .large, .svg-icon.large {
    width: 44px;
    height: 50px;
  }
</style>